<template>
  <div class="header">
    <div class="header-logo" @click="backHome">
      <!-- <img src="imgs/common/logo.png" class="logo" />
      <div>crystal 720</div> -->

      <img src="imgs/common/logo.png" class="logo" />
      <!-- <a href="/find">
        <div class>
          <img src="imgs/common/home.png" title="返回主页" class="icon-home" />
        </div>
      </a> -->
    </div>
    <div class="menus">
      <div v-for="(item,i) in menus" :key="i" :class="{'menu':true,'active':item.id===activeNum}">
        <router-link class="link" :to="item.link">{{item.title}}</router-link>
      </div>
      <div class="menu-upload" @mouseenter="showMenu = true" @mouseleave="showMenu = false">
        <router-link to="../my/pano?type=1" class="upload-btn">发布</router-link>

        <div class="menu-hide" v-if="showMenu">
          <div class="UploadSelect_block">
            <router-link to="../my/pano?type=1" :class="{'hide-li':true,'active':panoNum=='1'}">全景漫游</router-link>
            <router-link to="../my/pano?type=2" :class="{'hide-li':true,'active':panoNum=='2'}">全景视频</router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="user-block">
      <div class="Select_select" @mouseenter="showMenu2 = true" @mouseleave="showMenu2 = false">
        <div class="UploadSelect_user">
          <span>
            <img
              src="imgs/test/user.jpg"
            />
          </span>
          <span class="UploadSelect_text">{{name}}</span>
        </div>
        <div class="menu-hide" v-if="showMenu2">
          <div class="UploadSelect_block">
            <!-- <a :class="{'hide-li':true,'active':false}" @click='goHome'>个人主页</a> -->
            <!-- <router-link to='/my/account' :class="{'hide-li':true,'active':false}" >账号设置</router-link> -->
            <a :class="{'hide-li':true,'active':false}" @click='loginout'>退出登录</a>
          </div>
        </div>
      </div>

      <!-- <div class="Select_select"> -->
        <!-- <a href="https://720yun.com/my/msg/good" class="tip">
          <span></span>
        </a> -->
      <!-- </div> -->
    </div>
  </div>
</template>
<style scoped>
a {
  color: inherit;
  text-decoration: none;
}
.header {
  position: relative;
  height: 60px;
  background: #333;
  padding: 0 30px;
  color: #fff;
}

.header-logo {
  display: flex;
  align-items: center;
  position: absolute;
  left: 30px;
  height: 100%;
  top: 0px;
}

.logo {
  height: 40px;
  width: auto;
  margin-right: 10px;
  display: block;
}

.icon-home {
  width: 16px;
  height: 16px;
  margin-left: 20px;
  display: block;
}

.menus {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.menu {
  margin: 0 20px;
  display: inline-block;
  font-size: 14px;
  font-weight: bolder;
  padding: 4px 0 4px;
  border-bottom: 1px solid rgba(0, 0, 0, 0);
}

.link {
  color: white;
  text-decoration: none;
}

.menu.active,
.menu:hover {
  border-bottom-color: #fff;
}

.menu-upload {
  height: 100%;
  display: flex;
  align-items: center;
  color: #292929;
  position: relative;
}

.upload-btn {
  height: 24px;
  width: 63px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  margin: 0 20px;
  border-radius: 3px;
  background-color: #286efa;
  font-size: 14px;
  color: #fff;
  text-align: center;
  text-decoration: none;
  cursor: pointer;
}

.upload-btn:hover {
  background-color: #0057ff;
}

.menu-hide {
  width: 108px;
  position: absolute;
  top: 60px;
  left: -5px;
  padding: 10px;
  box-sizing: border-box;
  background-color: #4a4a4a;
  z-index: 10;
}

.hide-li {
  cursor: pointer;
  display: block;
  padding: 12px 0;
  text-align: center;
  color: hsla(0, 0%, 100%, 0.6);
}
.hide-li:hover,
.hide-li.active {
  color: white;
}

.user-block {
  display: flex;
  align-items: center;
  position: absolute;
  right: 30px;
  height: 100%;
  top: 0px;
}

.user-block .menu-hide{
  width: 125px;
  left: 5px;
}

.Select_select {
  height: 100%;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  position: relative;
  color: #292929;
}

.UploadSelect_user {
  width: 125px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  padding-left: 5px;
  min-width: 65px;
  color: #fff;
  font-weight: bolder;
  line-height: 1.2em;
  white-space: nowrap;
  overflow: hidden;
  cursor: pointer;
}

.UploadSelect_user img {
  height: 25px;
  width: 25px;
  border-radius: 50%;
  vertical-align: middle;
  background-color: rgb(244, 244, 244);
}

.UploadSelect_text {
  padding-left: 5px;
  display: inline-block;
  white-space: nowrap;
  -o-text-overflow: ellipsis;
  text-overflow: ellipsis;
  overflow: hidden;
  line-height: 1.2em;
}

.tip {
  background-image: url(../../public/imgs/common/tip.png);
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: 14px 16px;
  display: inline-block;
  vertical-align: middle;
  overflow: hidden;
  margin-left: 20px;
  width: 16px;
  height: 60px;
  cursor: pointer;
  position: relative;
}
</style>

<script>
import https from '../https.js'
import axios from 'axios'
export default {
  name: 'top',
  props: {
    activeNum: String,
    panoNum: String
    // userNum: String
  },
  data() {
    return {
      menus: [
        {
          id: '1',
          title: '管理首页',
          link: '../my/manage',
          children: []
        },
        {
          id: '2',
          title: '作品管理',
          link: '../my/product',
          children: []
        },
        {
          id: '3',
          title: '素材库',
          link: '../my/media',
          children: []
        },
        // {
        //   id: '4',
        //   title: '售图',
        //   link: '../test1',
        //   children: []
        // },
        // {
        //   id: '5',
        //   title: '订单',
        //   link: '../test1',
        //   children: []
        // },
        // {
        //   id: '6',
        //   title: '账户',
        //   link: '../test1',
        //   children: []
        // }
      ],
      showMenu: false,
      showMenu2: false,
      name: ''
    }
  },
  mounted() {
    https
      .fetchGet('/api/User/UserInfo')
      .then(res => {
        console.log(res)
        this.name = res.data.phoneNumber
      })
  },
  methods: {
    backHome() {
      this.$router.push({ path: '/' })
    },
    loginout() {
      https
        .fetchGet('/api/User/Logout')
        .then(res => {
          console.log(res)
          this.$router.push({ path: '/login' })
        })
    },
     goHome(){
       this.$router.push({path:'/my'})
    }
  }
}
</script>
